var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7944 20.4582C10.882 21.393 11.7107 22.0799 12.6455 21.9923C13.281 21.9328 13.8296 21.5224 14.0661 20.9296L19.8963 6.31261C20.2441 5.44054 19.8192 4.4516 18.9471 4.10376C18.5427 3.94246 18.0918 3.94246 17.6874 4.10376L3.07051 9.93399C2.19844 10.2818 1.77346 11.2708 2.1213 12.1428C2.35777 12.7357 2.90637 13.1461 3.54185 13.2056L10.1735 13.8266L10.7944 20.4582ZM18.1382 5.86189L12.5479 19.8772L11.8266 12.1735L4.12287 11.4521L18.1382 5.86189Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location_outline.2fa8ec024166465f7376924ac134d2a9.svg";
export { ForwardRef as ReactComponent };